import React from 'react';
import CommunityImg from '../CommunityImg/CommunityImg';
import { default as FSC} from '../../../images/sustainability_FSC.svg';
import { default as acid} from '../../../images/sustainability_acid_free.svg';
import { default as soy} from '../../../images/sustainability_soy_based.svg';
import { default as TUV} from '../../../images/sustainability_tuv_mailer.svg';
import { default as water} from '../../../images/sustainability_water_ink.svg';
import { default as goats} from '../../../images/GOTS_for_Totes.svg';
import { default as highQuality} from '../../../images/High_Quality.svg';
import { default as durable} from '../../../images/Durable.svg';
import { default as reusableIcon} from '../../../images/Reusable_icon.svg';
import { default as madeFrom} from '../../../images/Made_from_Recycled_Materials.svg';
import './SustainabilityCircular.scss';

const SustainabilityCircular = ({
  productType
}) => {


  const IconsDataCompostable = [
    { icon : FSC,  name : 'FSC® Certified', cls: "fsc"}, 
    { icon : soy, name : 'Soy Based Inks', cls: "soy" }, 
    { icon : water, name : 'Water Based Inks', cls: "water" },
    { icon : TUV, name : 'TUV for Mailers', cls: "tuv" }, 
    { icon : acid, name : 'Acid Free', cls: "acid" }
  ]

  const IconsDataRecycle = [
    { icon : FSC,  name : 'FSC® Certified', cls: "fsc" }, 
    { icon : soy, name : 'Soy Based Inks', cls: "soy" }, 
    { icon : water, name : 'Water Based Inks', cls: "water" },
    { icon : acid, name : 'Acid Free', cls: "acid" },
    { icon : madeFrom, name : 'Made From Recycled Materials', cls: "madefrom" }
  ]

  const IconsDataReusable = [
    { icon : goats,  name : 'GOTS for Totes', cls: "gots" }, 
    { icon : highQuality, name : 'High Quality', cls: "highquality" }, 
    { icon : durable, name : 'Durable', cls: "durable" },
    { icon : reusableIcon, name : 'Reusable', cls: "resuable" }, 
  ]

  const ProductInfo = {
    Compostable : {
      color: '#697F6C',
      title : 'Compostable',
      subHeading: 'From conceptualization, we create products that fit into a circular framework. For our compostable products, we encourage this by having our products be home and commercially compostable.',
    },
    Recycle : {
      color : '#3A3A6E',
      title : 'Recycled',
      subHeading: `We encourage circularity through the re-use of recycled materials and the end-of-life recycling of products! You'll find key information on what to do with your recyclable noissue Products on the product and/or on our website!`,
    },
    Reusable : {
      color: '#DE5F72',
      title : 'Reusable',
      subHeading: 'We encourage a Reusable economy through making high quality products that can be reused over and over again, reducing the need for new products to be made, and giving products a longer life!',
    }
  }

  return (
    <div className="sustainability-circular">
      <div className="left-side">
        <div className="heading" style={{color : ProductInfo[productType].color}}> The Circular Economy: {ProductInfo[productType].title} </div>
        <div className="subheading"> {ProductInfo[productType].subHeading} </div>
        <div className="sustainability-circular-points">
          <div className="point-details">
            "A circular economy aims to redefine growth, focusing on positive society-wide benefits. It entails gradually decoupling economic activity from the consumption of finite resources, and designing waste out of the system. 
            <br />
            It represents a systemic shift that builds long-term resilience, generates business and economic opportunities, and provides environmental and societal benefits."
            <br />
            <span>- Ellen MacArthur</span>
          </div>
        </div>
      </div>
      <div className="sustainability-circular-video">
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/EU5mz48ipOw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        <div className="sustainability-circular-video-icons">
          {
            productType === 'Compostable' &&
            IconsDataCompostable.map((item, idx) => {
              return (
                <div className="icon-item" key={idx}>
                  <div className="icon-item-img">
                    <CommunityImg className={item.cls} src={item.icon} alt="FSC" />
                  </div>
                  <span>{item.name}</span>
                </div>
              )
            })
          }
          {
            productType === 'Recycle' &&
            IconsDataRecycle.map((item, idx) => {
              return (
                <div className="icon-item" key={idx}>
                  <div className="icon-item-img">
                    <CommunityImg className={item.cls} src={item.icon} alt="FSC" />
                  </div>
                  <span>{item.name}</span>
                </div>
              )
            })
          }
          {
            productType === 'Reusable' &&
            IconsDataReusable.map((item, idx) => {
              return (
                <div className="icon-item" key={idx}>
                  <div className="icon-item-img">
                    <CommunityImg className={item.cls} src={item.icon} alt="FSC" />
                  </div>
                  <span>{item.name}</span>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default SustainabilityCircular;